/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../client.ts';
import type {
  TelegramChatsUserControllerCreateMessageMutationRequest,
  TelegramChatsUserControllerCreateMessageMutationResponse,
  TelegramChatsUserControllerCreateMessagePathParams,
  TelegramChatsUserControllerCreateMessage401,
  TelegramChatsUserControllerCreateMessage403,
  TelegramChatsUserControllerCreateMessage404,
} from '../types/TelegramChatsUserControllerCreateMessage.ts';

function getTelegramChatsUserCreateMessageUrl(id: TelegramChatsUserControllerCreateMessagePathParams['id']) {
  const res = { method: 'POST', url: `/api/user/telegram/chats/${id}/message` as const };
  return res;
}

/**
 * {@link /api/user/telegram/chats/:id/message}
 */
export async function telegramChatsUserCreateMessage(
  id: TelegramChatsUserControllerCreateMessagePathParams['id'],
  data?: TelegramChatsUserControllerCreateMessageMutationRequest,
  config: Partial<RequestConfig<TelegramChatsUserControllerCreateMessageMutationRequest>> & {
    client?: typeof fetch;
  } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData = data;

  const res = await request<
    TelegramChatsUserControllerCreateMessageMutationResponse,
    ResponseErrorConfig<
      | TelegramChatsUserControllerCreateMessage401
      | TelegramChatsUserControllerCreateMessage403
      | TelegramChatsUserControllerCreateMessage404
    >,
    TelegramChatsUserControllerCreateMessageMutationRequest
  >({
    method: 'POST',
    url: getTelegramChatsUserCreateMessageUrl(id).url.toString(),
    data: requestData,
    ...requestConfig,
  });
  return res.data;
}
